import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { IconX } from '@tabler/icons-react';
import { FC } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { BoatPhotosQuery } from '../../../gql/graphql';
import CdnImage from '../../../components/CdnImage';

interface Props {
  showBoatPhotos: boolean;
  setShowBoatPhotos: (show: boolean) => void;
  isDesktopVersion: boolean;
  boatPhotos: BoatPhotosQuery | undefined;
}

const BoatPhotoDialog: FC<Props> = ({
  showBoatPhotos,
  setShowBoatPhotos,
  isDesktopVersion,
  boatPhotos,
}) => {
  return (
    <Dialog
      open={showBoatPhotos}
      onClose={() => setShowBoatPhotos(false)}
      fullScreen={!isDesktopVersion}
      sx={
        isDesktopVersion
          ? {}
          : {
              height: '90%',
              top: 'unset',
            }
      }
      slotProps={{
        paper: isDesktopVersion
          ? {
              sx: { borderRadius: '1.5rem' },
            }
          : { sx: { borderRadius: '1.5rem 1.5rem 0 0' } },
      }}
    >
      {isDesktopVersion ? null : (
        <DialogTitle>
          <div className="flex items-center justify-between">
            <IconButton onClick={() => setShowBoatPhotos(false)}>
              <IconX size={16} />
            </IconButton>
            <span className="font-semibold">Photos</span>
            <span></span>
          </div>
        </DialogTitle>
      )}
      <DialogContent dividers>
        <div className="flex justify-end mb-6">
          <button type="button" onClick={() => setShowBoatPhotos(false)}>
            <IconX size={20} />
          </button>
        </div>
        <Carousel
          showArrows={isDesktopVersion}
          showIndicators={false}
          showThumbs={false}
        >
          {boatPhotos?.boatPhotos.map((photo, index) => (
            <div key={index}>
              <CdnImage
                className="rounded-2xl"
                src={photo.imageUrl}
                variant="BOATPAGE"
                alt="trip image"
              />
            </div>
          ))}
        </Carousel>
      </DialogContent>
      <DialogActions>
        <button
          className="flex px-6 py-3 justify-center items-center gap-2 rounded-lg border border-neutral-800"
          onClick={() => setShowBoatPhotos(false)}
        >
          <span className="font-semibold">Close</span>
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default BoatPhotoDialog;
